export default __webpack_public_path__ + "static/cross-image-18bdbbbf1b4b8e27e10b1208a7d813db.png";